import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const recyclingMaterialsImporterSelectors = importerSelectors(
  'recyclingMaterials.importer',
);

export default recyclingMaterialsImporterSelectors;
